import { AbilityAccessors } from '../../Ability';
import { AbilityStatEnum } from '../../Core';
import { ModifierBonusTypeEnum, ModifierDerivers, ModifierUtils, ModifierValidators } from '../../Modifier';
/**
 *
 * @param modifiers
 * @param abilityLookup
 * @param profBonus
 */
export function getInitiative(modifiers, abilityLookup, profBonus) {
    const bonusInitiativeModifiers = modifiers.filter((modifier) => ModifierValidators.isBonusInitiativeModifier(modifier));
    const bonusInitiativeModifierTotal = ModifierDerivers.sumModifiers(bonusInitiativeModifiers, abilityLookup);
    const includeProficiencyBonus = ModifierUtils.countModifierBonusTypes(bonusInitiativeModifiers, ModifierBonusTypeEnum.PROFICIENCY_BONUS) > 0;
    let halfProficiency = false;
    if (modifiers.filter((modifier) => ModifierValidators.isHalfProficiencyInitiativeModifier(modifier)).length) {
        halfProficiency = true;
    }
    let halfProficiencyRoundUp = false;
    if (modifiers.filter((modifier) => ModifierValidators.isHalfProficiencyRoundUpInitiativeModifier(modifier)).length) {
        halfProficiencyRoundUp = true;
    }
    let modifierProficiencyBonus = 0;
    if (includeProficiencyBonus) {
        modifierProficiencyBonus = profBonus;
    }
    else if (halfProficiencyRoundUp) {
        modifierProficiencyBonus = Math.ceil(profBonus / 2);
    }
    else if (halfProficiency) {
        modifierProficiencyBonus = Math.floor(profBonus / 2);
    }
    const dexAbility = abilityLookup[AbilityStatEnum.DEXTERITY];
    const modifier = AbilityAccessors.getModifier(dexAbility);
    const dexAbilityModifier = modifier ? modifier : 0;
    return dexAbilityModifier + bonusInitiativeModifierTotal + modifierProficiencyBonus;
}
/**
 * //TODO use array.some prototype
 * @param modifiers
 */
export function generateHasInitiativeAdvantage(modifiers) {
    return modifiers.filter((modifier) => ModifierValidators.isAdvantageInitiativeModifier(modifier)).length > 0;
}
